import CMCFAQ from '@/components/CMCFAQ';
import DigiCertMarkPricing from '@/components/DigiCertMarkPricing';
import VMCCompareTable from '@/components/VMCCompareTable';
import VMCFAQ from '@/components/VMCFAQ';
import { getSpecificProducts } from '@/data/products';
import Head from 'next/head';

const DigiCertMarkCertificates = () => {
  const productOrder = ['common-mark-certificate', 'verified-mark-certificate'];
  const markCertificates = getSpecificProducts(...productOrder).sort(
    (a, b) => productOrder.indexOf(a.id) - productOrder.indexOf(b.id)
  );

  if (markCertificates.length !== 2) {
    console.error('Expected 2 products, got:', markCertificates.length);
  }

  return (
    <div>
      <Head>
        <title>DigiCert Mark Certificates: VMC & CMC for Email Brand Trust | Brandymail</title>
        <meta
          name="description"
          content="Compare DigiCert Verified Mark Certificate (VMC) & Common Mark Certificate (CMC). Display your logo in Gmail, enhance email trust, and protect your brand with BIMI-ready certificates."
        />
        <link rel="canonical" href="https://brandymail.com/products/digicert-mark-certificates" />

        {/* Open Graph / Facebook */}
        <meta property="og:type" content="website" />
        <meta
          property="og:url"
          content="https://brandymail.com/products/digicert-mark-certificates"
        />
        <meta
          property="og:title"
          content="DigiCert Mark Certificates: VMC & CMC for Email Brand Trust | Brandymail"
        />
        <meta
          property="og:description"
          content="Compare DigiCert Verified Mark Certificate (VMC) & Common Mark Certificate (CMC). Display your logo in Gmail, enhance email trust, and protect your brand with BIMI-ready certificates."
        />
        <meta
          property="og:image"
          content="https://brandymail.com/images/og-digicert-mark-certificates.png"
        />
        <meta property="og:image:width" content="1200" />
        <meta property="og:image:height" content="630" />
        <meta
          property="og:image:alt"
          content="DigiCert Mark Certificates Comparison - VMC vs CMC"
        />

        {/* Twitter */}
        <meta name="twitter:card" content="summary_large_image" />
        <meta
          name="twitter:url"
          content="https://brandymail.com/products/digicert-mark-certificates"
        />
        <meta
          name="twitter:title"
          content="DigiCert Mark Certificates: VMC & CMC for Email Brand Trust | Brandymail"
        />
        <meta
          name="twitter:description"
          content="Compare DigiCert Verified Mark Certificate (VMC) & Common Mark Certificate (CMC). Display your logo in Gmail, enhance email trust, and protect your brand with BIMI-ready certificates."
        />
        <meta
          name="twitter:image"
          content="https://brandymail.com/images/twitter-digicert-mark-certificates.png"
        />
        <meta
          name="twitter:image:alt"
          content="DigiCert Mark Certificates Comparison - VMC vs CMC"
        />
      </Head>
      <section className="products section hero v9">
        <div className="container-default w-container">
          <div className="position-relative z-index-1">
            <div className="mg-bottom-48px">
              <div className="inner-container _989px center">
                <div className="inner-container _600px---tablet center">
                  <div className="text-center">
                    <div className="mg-bottom-24px">
                      <div className="text-100 bold color-accent-1 text-uppercase">
                        AS LOW AS $89/MONTH
                      </div>
                    </div>
                    <h1 className="display-1 color-neutral-100 mg-bottom-24px">
                      DigiCert Mark Certificates
                    </h1>
                    <p className="color-neutral-300 mg-bottom-0 paragraph-large">
                      Showcase your logo and/or a verified blue checkmark in Gmail on every email
                      you send. With a DigiCert Mark Certificate, you'll be able to create a trusted
                      email & immersive brand experience that increases email engagement leading to
                      more conversion. There are two types of DigiCert Mark Certificates, a Verified
                      Mark Certificate (VMC) and a Common Mark Certificate (CMC). The type of logo
                      that you have will determine which one you qualify for.
                    </p>
                  </div>
                </div>
              </div>
            </div>
            <div className="text-center mg-bottom-48px">
              <img
                src="/images/logo-digicert-blue.svg"
                alt="DigiCert Logo"
                className="mx-auto"
                style={{ maxWidth: '200px' }}
              />
            </div>
            <DigiCertMarkPricing products={markCertificates} />
          </div>
        </div>
        <div className="position-absolute dark-fade---button pricing-fade"></div>
        <div className="position-absolute card-top-bg---bottom pricing-bg"></div>
      </section>

      <VMCCompareTable />

      <VMCFAQ />

      <CMCFAQ />
    </div>
  );
};

export default DigiCertMarkCertificates;
